import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/antd/node_modules/rc-calendar/es/index.js
// module id = 259
// module chunks = 0